import { Inputs } from "@thisgorilla/primate-ds";
import { Field, FieldProps } from "formik";
import { useContext } from "react";
import styled from "styled-components";
import instance from "../../../../../../axios/axios-user";
import { hideScrollBar } from "../../../../../../commonStyles";
import { useAppSelector } from "../../../../../../redux";
import {
  CREATE_POST_RICH_TEXT_AREA_HEIGHT,
  getMentionList,
  RICHTEXT_INITIAL_VALUE,
} from "../../../../../../utils";
import { ModalContext } from "../../../../../Common/Modal";
import { CreateRepostFooter } from "../3-Footer";

export const CreateRepostContent = () => {
  const { post_theme, suggestedUsers } = useAppSelector((state) => state.me);
  const { contentRef } = useContext(ModalContext);

  const fieldName = "content";

  return (
    <Container ref={contentRef} id="create-repost-modal-content">
      <Field key={fieldName} name={fieldName}>
        {({ field, form }: FieldProps) => {
          const { value } = field;
          const { setFieldValue } = form;

          return (
            <Inputs.RichTextarea
              axiosInstance={instance}
              fieldName={fieldName}
              idPrefix="richtext"
              placeholder={post_theme}
              minHeight={CREATE_POST_RICH_TEXT_AREA_HEIGHT}
              variant="Post"
              isRequired={false}
              mentionList={getMentionList(suggestedUsers)}
              value={value}
              onChangeHandler={(_, html) => {
                const isFieldUnchanged =
                  !html || html === RICHTEXT_INITIAL_VALUE;

                if (isFieldUnchanged) setFieldValue(fieldName, "");
                else setFieldValue(fieldName, html);
              }}
              footerComponent={<CreateRepostFooter />}
              scrollAreaId="create-repost-modal-content"
            />
          );
        }}
      </Field>
    </Container>
  );
};

const Container = styled.div`
  max-height: calc(100vh - 277px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;

  ${hideScrollBar}
`;
